import { render, staticRenderFns } from "./OrganizerCard.vue?vue&type=template&id=66e5268c&scoped=true&"
import script from "./OrganizerCard.vue?vue&type=script&lang=js&"
export * from "./OrganizerCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerCard.vue?vue&type=style&index=0&id=66e5268c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5268c",
  null
  
)

export default component.exports